//import { Link } from "react-router-dom";

export default function NavBar() {
  return (
    <nav className="navbar mb-2">
        <div className="container justify-content-center">
            <a className="navbar-brand fw-bold d-flex col-auto text-decoration-none" href="/">
              AI for Models and Logs
              <span className="logo"><img src="images/logo.svg" className="img-fluid" alt="GEO Services"/> </span>
            </a>
        </div>
    </nav>
  );
}
